import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDxpOHuY4xiLnuEuhVgtPTRM0YuwBkQPeU",
  authDomain: "haqdarshak-dashboards.firebaseapp.com",
  projectId: "haqdarshak-dashboards",
  storageBucket: "haqdarshak-dashboards.firebasestorage.app",
  messagingSenderId: "930886517551",
  appId: "1:930886517551:web:7440abf98a1f26c1ee57da",
  measurementId: "G-JNLMWZDL6Q"
};

const app = initializeApp(firebaseConfig);
let analytics = null;
if (typeof window !== "undefined") {
  try {
    analytics = getAnalytics(app);
  } catch (e) {
    console.warn("Analytics not available on localhost");
  }
}
export { analytics };

export const db = getFirestore(app);
